module.exports = __webpack_public_path__ + "img/IMG_6258_L_Foamcore_MockedUp.e6219d70.jpg";